import _ from 'lodash'
import {sort} from '@/utils/utils'
import { compileFunction } from 'vm'
//import {getMapData, getCloudData, getTreemapData} from '@/utils/dataset'
import i18n from '@/locale/game';
import moment from 'moment';

// 将数字格式化
export const numberFormat = (num, dotNum = 2) => {
    const beauty = str => str.replace(/(\.0+$)|(\.\d0)$/, (match, p1, p2) => {
        if (p1 !== undefined) { return '' }
        if (p2 !== undefined) { return p2.slice(0, -1) }
        return match
    })
    if (i18n && i18n.locale === 'en_US') {
        if (Math.abs(num) >= 1000000) {
            return `${beauty((num / 1000000).toFixed(dotNum))} m`
        } else if (Math.abs(num) >= 1000) {
            return `${beauty((num / 1000).toFixed(dotNum))} k`
        }
    } else {
        if (Math.abs(num) >= 100000000) {
            return `${beauty((num / 100000000).toFixed(dotNum))} 亿`
        } else if (Math.abs(num) >= 10000) {
            return `${beauty((num / 10000).toFixed(dotNum))} 万`
        }        
    }
    
    return num
}

export const format = (value, round) => {
    if(_.isNil(value)) {
        return '/'
    }
    if(!isNaN(value))
        return round?Math.round(value).toLocaleString():value.toLocaleString(undefined, { maximumFractionDigits: 4 })
    else
        return value
}

const formatAxis = (val) => {
    let newV = val.replace(/[^\w\s]|_/g, "").replace(/\s+/g, "")
    if(!isNaN(newV)) {
        return val
    }
    return val.length>15?`${val.substring(0,15)}...`:val
}

// 将id翻译为fields中对应的title
const transformField = (type, id, fields) => {
    let field = _.find(fields, {id})
    if(field) {
      return field[type] ? field[type] : ''
    }
    return ''
}

// // 世界地图数据
// export const worldGeoData = ()=>{
//     const DataSet = require('@antv/data-set');
//     return new DataSet.View().source(require('@/utils/worldGeo.json'), {type: 'GeoJSON'})
// }
// // 中国地图数据
// export const chinaGeoData  = ()=>{
//     const DataSet = require('@antv/data-set');
//     return new DataSet.View().source(require('@/utils/chinaGeo.json'), {type: 'GeoJSON'});
// }

// ----------------------------- 转换图表类型----------------------------------- 
const getType = (type, series_type) => {
    let newtype;
    switch(type) {
        case 'pie':
            newtype = 'stackInterval'
            break; 
        case 'polar':
            newtype = 'area'
            break; 
        case 'spline':
            newtype = 'smoothLine'
            break;
        case 'area':
            if(series_type == 'stack') {
                newtype = 'stackArea'
                break;
            }
            newtype = 'area'
            break;
        case 'bar':
            if(series_type == 'stack') {
                newtype = 'stackBar'
                break;
            } 
            else if(series_type == 'team') {
                newtype = 'dodgeBar'
                break;
            }
            newtype = 'bar'
            break;
        case 'treemap':
            newtype = 'polygon'
            break;
        default:
            newtype = type
    }
    return newtype
}
export const initType = (conf) => {
    if(conf.type != 'mixin') {
        return getType(conf.type, conf.series?conf.series.type:null)
    }
    
    let left=false, right=false
    if(conf.y) {
        conf.y.forEach((f)=>{
            if(f.pos!='r') {
                left = true
            }
            else {
                right = true
            }
        })
    }

    let type={};
    if(left) {
        if(conf.yaxis && conf.yaxis.left && conf.yaxis.left.type) {
            type.left = getType(conf.yaxis.left.type, conf.yaxis.left.series_type, null)
        }
        else {
            type.left = 'bar'
        }
    }
    if(right) {
        if(conf.yaxis && conf.yaxis.right && conf.yaxis.right.type) {
            type.right = getType(conf.yaxis.right.type, conf.yaxis.right.series_type, null)
        }
        else {
            type.right = 'line'
        }
    }
    return type
}

// ------------------------------- 翻译度量 ------------------------------------ 
const getScale = (field, fields, type, x) => {
    let scale = {
        dataKey: field.id, 
        alias: field.title?field.title:transformField('title', field.id, fields)
    }
    if(type) {
        if(field.type!='inherit') {
            if(field.type) {
                scale.type = field.type
            }
            else {
                scale.type = 'cat'
            }
        }
    }
    if('max' in field) {
        scale.max = field.max
        scale.min = 0
    }
    if('min' in field) {
        scale.min = field.min
    }
    let suffix = 'suffix' in field ? field.suffix : transformField('suffix', field.id, fields)
    if(suffix) {
        scale.formatter = (value)=>value==null?null:`${value}${suffix}`
    }
    // scale.formatter = (value)=>{ 
    //     if(!isNaN(value))
    //         return `${value.toLocaleString()}${suffix?suffix:''}`
    //     return `${value}${suffix?suffix:''}`
    // }
    if(field.ticks) {
        scale.ticks=field.ticks
    }
    if('tickCount' in field) {
        if(field.tickCount) {
            scale.tickCount=field.tickCount
            if(x && x.length<field.tickCount) {
                scale.tickCount = x.length
            }
        }
    }
    else {
        if(x && x.length >= 50 && scale.type == 'cat') {
            scale.tickCount = 50
        }
    }
    if(field.tickInterval) {
        scale.tickInterval=field.tickInterval
    }
    if(field.mask) {
        scale.mask = field.mask
    }
    if (field.values) {
        scale.values = field.values
    }
    return scale
}

export const initScale = (conf, datas, fields, slider)=>{
    if(conf.type=='cloud') {
        return [
            {dataKey: 'x', nice:false },
            {dataKey: 'y', nice:false }
        ]
    }
    if(conf.type=='worldmap' || conf.type=='chinamap') {
        return [
            {dataKey: 'longitude', sync: true, nice:false}, 
            {dataKey: 'latitude', sync: true, nice:false}
        ]
    }
    if(conf.type=='treemap') {
        return [{dataKey:'value', nice:false}]
    }
    if(conf.type=='heatmap') {
        let scales = []
        if(conf.x instanceof Object) {
            let x = {dataKey:conf.x.id, type:'linear', nice:false}
            x.min = 0
            if(conf.x.max) {
                x.max = conf.x.max
            }
            if(conf.x.min) {
                x.min = conf.x.min
            }
            scales.push(x)
        }
        if(conf.y instanceof Object) {
            let y = {dataKey:conf.y.id, type:'linear', nice:false}
            y.min = 0
            if(conf.y.max) {
                y.max = conf.y.max
            }
            if(conf.y.min) {
                y.min = conf.y.min
            }
            scales.push(y)
        }
        if(conf.series instanceof Object) {
            scales.push({dataKey:conf.series.id, type:'linear'})
        }
        return scales
    }
    if (conf.type == 'polygon') {
        const { id: xID, ...extraXScale } = conf.x; 
        const { id: yID, ...extraYScale } = conf.y;
        const { id: sID, ...extraSeries  } = conf.series;
        let scales = [
            {dataKey: xID, nice:false, type: 'cat', ...extraXScale },
            {dataKey: yID, nice:false, type: 'cat', ...extraYScale }
        ];
        if (conf.series instanceof Object) {
            scales.push({ dataKey:conf.series.id, type:'linear', ...extraSeries });
        }
        return scales;
    }
    let scales = []
    let x = conf.x&&conf.x.id?_.uniq(_.map(datas, conf.x.id)):[]
    if(conf.type != 'mixin') {
        // 解析x
        if(conf.x instanceof Object) {
            let scale = getScale(conf.x, fields, conf.type!='cloud'?true:null, x)
            if(((conf.fixed===true || conf.home===true) && conf.x && conf.x.id=='ds') || conf.weekday) {
                if(x.length<=62) {
                    delete scale.tickCount
                }
                if(slider && slider.length==2 && slider[0] && slider[1]) {
                    x = _.filter(x, (d)=>d>=slider[0] && d<=slider[1])
                }
                scale.values = sort(x);
                scale.formatter=(x)=>{return x.split('-')[1] +'-'+ x.split('-')[2]}
            }
            if(conf.fixed===true && conf.x && conf.x.id=='weekname') {
                delete scale.tickCount
            }
            scales.push(scale)
        }
        if(conf.type == 'box' || conf.type == 'candle') {
            scales.push({dataKey:'range'})
        }
        else {
            // 解析y
            if(conf.y instanceof Array) {
                conf.y.forEach((y)=>{
                    if(y instanceof Object) {
                        let yscale = getScale(y, fields)
                        yscale.min = 0
                        scales.push(yscale)
                    }
                })
            }
            else if(conf.y instanceof Object) {
                let yscale = getScale(conf.y, fields)
                let ys = _.uniq(_.map(datas, conf.y.id))
                if(conf.y.start_at_0!==false) {
                    if(_.min(ys)>=0) {
                        yscale.min = 0
                    }
                }
                scales.push(yscale)
            }
        }
        if(conf.series && conf.series.id) {
            scales.push({dataKey:conf.series.id, type:'cat', ...(_.isNil(conf.series.vals) ? {} : {values: conf.series.vals})})
        }
    }
    else {
        // 解析x
        if(conf.x instanceof Object) {
            let scale = getScale(conf.x, fields, conf.type!='cloud'?true:null, x)
            scale.dataKey = 'x'
            scales.push(scale)
        }
        // 解析y
        if(conf.yaxis && conf.yaxis.left) {
            let scale = getScale(conf.yaxis.left, [], null)
            scale.dataKey = 'y'
            let ys = []
            if(conf.y) {
                conf.y.forEach((y)=>{
                    if(y.pos == 'l') {
                        ys = _.concat(ys, _.map(datas, y.id))
                    }
                })
                if(_.min(ys)>=0) {
                    scale.min = 0
                }
            }
            scales.push(scale)
        }
        if(conf.yaxis && conf.yaxis.right) {
            let scale = getScale(conf.yaxis.right, [], null)
            scale.dataKey = 'r'
            let ys = []
            conf.y.forEach((y)=>{
                if(y.pos == 'r') {
                    ys = _.concat(ys, _.map(datas, y.id))
                }
            })
            if(conf.yaxis.start_at_0!==false) {
                if(_.min(ys)>=0) {
                    scale.min = 0
                }
            }
            scales.push(scale)
        }
        scales.push({dataKey:'series', type:'cat'})
    }
    return scales
}


// ------------------------------- 转化坐标轴 ------------------------------------ 
export const initAxis = (conf, fields, datas)=>{
    if(['pie', 'pyramid', 'cloud', 'worldmap', 'chinamap', 'treemap', 'heatmap', 'polygon'].indexOf(conf.type) >= 0) {
        return []
    }
    let axises = []
    // 解析x
    let x = []
    if(conf.x && conf.x.id) {
        x = _.uniq(_.map(datas, conf.x.id))
    }
    if(conf.x instanceof Object) {
        let axis = {
            dataKey: conf.type=='mixin'?'x':conf.x.id,
            position: 'bottom',
            title: conf.x.title?conf.x.title:transformField('title', conf.x.id, fields),
            label: {
                autoRotate: true
            },
        }
        let rotate = null
        if(!_.isNil(conf.x.rotate)) {
            rotate = conf.x.rotate
        }
        else if(conf.fixed!==true && conf.home!==true && !conf.x.tickCount && !conf.x.tickInterval && conf.x.type!='linear') {
            if(x.length>=50) {
                rotate =  40
            }
            else if(x.length>=30) {
                rotate =  30
            }
            else if(x.length>=20) {
                rotate =  20
            }
        }
        if(rotate!=null) {
            axis.label = {
                autoRotate: false,
                rotate: rotate,
                formatter: formatAxis,
                textStyle: {
                    textAlign: rotate==0?'center':'start',
                    textBaseline: 'bottom',
                },
                offset: 20,
            }
        }
        if(conf.x.fontSize) {
            axis.label.textStyle.fontStyle = {
                fontSize: conf.x.fontSize
            }
        }
        if(conf.other && conf.other.xaixs && conf.other.xaixs.htmlTemplate) {
            axis.label.htmlTemplate = conf.other.xaixs.htmlTemplate
        }
        if(conf.type=='polar') {
            axis.grid = {
                lineStyle: { lineDash: null},
                hideFirstLine: false,
            }
        }
        axises.push(axis)
    }
    if(conf.type != 'mixin' && conf.y instanceof Object) {
        let axis = {
            dataKey: conf.y.id,
            position: 'left',
            title: {
                text: conf.y.title?conf.y.title:transformField('title', conf.y.id, fields), 
                offset:-20, 
                position:'end', 
                textStyle: {textAlign:'start', rotate:0}
            },
            label: {
                autoRotate: false,
                formatter: (value) => {
                    if(conf.y.suffix) {
                        return `${numberFormat(value.split(conf.y.suffix)[0])}${conf.y.suffix}`;
                    }
                    return numberFormat(value)
                }
            }
        }
        if(conf.type=='polar') {
            axis.grid = {
                type: 'polygon',
                lineStyle: { lineDash: null,},
            }
        }
        axises.push(axis)
    }
    else if(conf.type == 'mixin' && conf.y instanceof Array) {
        let left=false, right=false
        conf.y.forEach((f)=>{
            if(f.pos!='r') {
                left = true
            }
            else {
                right = true
            }
        })
        if(conf.yaxis.left && left===true) {
            axises.push({
                dataKey: 'y',
                position: 'left',
                title: {
                    text: conf.yaxis.left.title?conf.yaxis.left.title:'', 
                    offset:-20, 
                    position:'end', 
                    textStyle: {textAlign:'start', rotate:0}
                },
                label: {
                    autoRotate: false,
                    formatter: (value) => {
                        if(conf.yaxis.left.suffix) {
                            return `${numberFormat(value.split(conf.yaxis.left.suffix)[0])}${conf.yaxis.left.suffix}`;
                        }
                        return numberFormat(value)
                    }
                },
            })
        }
        if(conf.yaxis.right && right===true) {
            axises.push({
                dataKey: 'r',
                position: 'right',
                title: {
                    text: conf.yaxis.right.title?conf.yaxis.right.title:'', 
                    offset:-20, 
                    position:'end', 
                    textStyle: {textAlign:'end', rotate:0}
                },
                label: {
                    autoRotate: false,
                    formatter: (value) => {
                        if(conf.yaxis.right.suffix) {
                            return `${numberFormat(value.split(conf.yaxis.right.suffix)[0])}${conf.yaxis.right.suffix}`;
                        }
                        return numberFormat(value)
                    }
                },
                grid: null
            })
        }
    }
    return axises
}


// ------------------------------- 处理数据 ------------------------------------
export const initData = (conf, ndatas, fields, sorter)=>{
    if(['worldmap', 'chinamap', 'cloud', 'treemap'].indexOf(conf.type)>=0) {
        return []
    }
    let datas = _.cloneDeep(ndatas)
    datas = _.filter(datas, (d)=>d.exclude_for_chart!=true)

    if(conf.reverse == true) {
        datas = _.reverse(datas)
    }
    // cat情况、series情况需要把数字转化为字符串
    if((conf.x && (conf.x.type == null || conf.x.type == 'cat')) || (conf.series && conf.series.id)) {
        let trans_series = conf.series && conf.series.id?true:false
        let trans_x = (conf.x && (conf.x.type == null || conf.x.type == 'cat'))?true:false
        datas.forEach((row)=>{
            if(trans_x === true) {
                row[conf.x.id] = row[conf.x.id]!=null && row[conf.x.id]!=undefined?row[conf.x.id].toString():row[conf.x.id]
            }
            if(trans_series === true) {
                row[conf.series.id] = row[conf.series.id]!=null?row[conf.series.id].toString():row[conf.series.id]
            }
        })
    }
    if(sorter && sorter!='default_sorter' && conf.series && conf.series.id && conf.x && conf.x.id && conf.y && conf.y.id) {
        const _sorter = sorter.substring(0, sorter.lastIndexOf('-'))
        const _sorter_dir = sorter.substring(sorter.lastIndexOf('-')+1)
        const _sorter_datas = datas.filter(d=>d[conf.series.id]===_sorter).sort((a, b)=>{
            if(_sorter_dir==='asc') {
                return a[conf.y.id] > b[conf.y.id]?1:a[conf.y.id] === b[conf.y.id]?0:-1
            }
            else {
                return a[conf.y.id] > b[conf.y.id]?-1:a[conf.y.id] === b[conf.y.id]?0:1
            }
        })
        const _sorter_map = {}
        _sorter_datas.forEach((row,ri)=>{
            if(!_sorter_map[row[conf.x.id]]) {
                _sorter_map[row[conf.x.id]] = ri
            }
        })
        
        datas.sort((a, b)=>{
            return _sorter_map[a[conf.x.id]] > _sorter_map[b[conf.x.id]]?1:_sorter_map[a[conf.x.id]] === _sorter_map[b[conf.x.id]]?0:-1
        })
    }
    else if(conf.x && conf.x.sort) {
        datas.sort((a, b)=>{
            return a[conf.x.id] > b[conf.x.id]?1:a[conf.x.id] === b[conf.x.id]?0:-1
        })
    }
    if(conf.type == 'pie') {
        let newdatas = []
        let has_value = false
        datas.forEach((row)=>{
            let newrow = {}
            newrow[conf.x.id] = row[conf.x.id]
            newrow[conf.y.id] = row[conf.y.id]
            if(conf.y.id!='ratio' && row['ratio']) {
                newrow['ratio'] = row['ratio']
            }
            if(row[conf.y.id]) {
                has_value = true
            } 
            newdatas.push(newrow)
        })
        if(!has_value && newdatas.length>0) {
            newdatas.forEach((row)=>{
                row.piechart_empty = true
                row[`fake_${conf.y.id}`] = 1
            })
        }
        return newdatas
    }
    if(conf.type == 'box') {
        datas.forEach((row)=>{
            row.range = [row.low, row.q1, row.median, row.q3, row.high]
        })
        return datas
    }
    if(conf.type == 'candle') {
        datas.forEach((row)=>{
            row.range = [row.start, row.end, row.high, row.low]
            row.trend = row.start <= row.end ? '上涨': '下跌'
        })
        return datas
    }
    if(conf.type == 'mixin') {
        let ndatas = [[], []]
        let _datas = []
        if(!conf.series) {
            if(conf.y) {
                conf.y.forEach((y)=> {
                    let s = y.title?y.title:transformField('title', y.id, fields)
                    if(typeof(s)=='number') {
                        s = s.toString()
                    }
                    let suffix = y.suffix?y.suffix:transformField('suffix', y.id, fields)
                    datas.forEach((row)=> {
                        if(y.pos=='r') {
                            if(conf.yaxis.right.series_type == 'updown' && conf.yaxis.left.type == 'bar') {
                                if(row[y.id] >= 0) {
                                    let y_row_pos = {x:row[conf.x.id], y:row[y.id], series:`${s}(正)`, suffix:suffix?suffix:''}
                                    ndatas[1].push(y_row_pos)
                                }
                                if(row[y.id] < 0) {
                                    let y_row_neg = {x:row[conf.x.id], y:row[y.id], series:`${s}(负)`, suffix:suffix?suffix:''}
                                    ndatas[1].push(y_row_neg)                                  
                                }
                            } else {
                                let y_row = {x:row[conf.x.id], r:row[y.id], series:s, suffix:suffix?suffix:''}
                                if(conf.versionday) {
                                    y_row['is_version_day'] = row['is_version_day']
                                }
                                ndatas[1].push(y_row)
                            }
                        }
                        else {
                            if(conf.yaxis.left.series_type == 'updown' && conf.yaxis.left.type == 'bar') {
                                if(row[y.id] >= 0) {
                                    let y_row_pos = {x:row[conf.x.id], y:row[y.id], series:`${s}(正)`, suffix:suffix?suffix:''}
                                    ndatas[0].push(y_row_pos)
                                }
                                if(row[y.id] < 0) {
                                    let y_row_neg = {x:row[conf.x.id], y:row[y.id], series:`${s}(负)`, suffix:suffix?suffix:''}
                                    ndatas[0].push(y_row_neg)                                  
                                }
                            } else {
                                let y_row = {x:row[conf.x.id], y:row[y.id], series:s, suffix:suffix?suffix:''}
                                if(conf.versionday) {
                                    y_row['is_version_day'] = row['is_version_day']
                                }
                                ndatas[0].push(y_row)
                            }
                        
                        }
                    })
                })
            }
        } else {
            conf.y.forEach((y)=> {
                datas.forEach((row)=> {
                    if(y.pos=='r')
                        ndatas[1].push({x:row[conf.x.id], r:row[y.id], series:y.title?`${row[conf.series.id]}-${y.title}`:`${row[conf.series.id]}-${transformField('title', y.id, fields)}`, series_id:y.id})
                    else
                        ndatas[0].push({x:row[conf.x.id], y:row[y.id], series:y.title?`${row[conf.series.id]}-${y.title}`:`${row[conf.series.id]}-${transformField('title', y.id, fields)}`, series_id:y.id})
                })
            })
        }
        return ndatas
    }
    return datas
}

// ------------------------------- 初始化提示格式 ------------------------------------
export const initTooltip = (conf, fields)=>{
    if(conf.custom_tooltip) {
        if(conf.custom_tooltip instanceof Array && conf.custom_tooltip.length>=2 && typeof conf.custom_tooltip[1] === 'string') {
            return [conf.custom_tooltip[0], eval(conf.custom_tooltip[1])]
        }
        return conf.custom_tooltip
    }
    if(conf.tooltip instanceof Object) {
        
        return conf.tooltip
    }
    if(conf.type == 'box') {
        return [
            `${conf.x.id}*low*q1*median*q3*high${conf.series?`*${conf.series.id}`:''}`, 
            (x, low, q1, median, q3, high, series) => ({ 
                name: series?series:x, 
                value:`<br/ >最大值:${high}<br/ >上四分位数:${q3}<br />中位数:${median}<br />下四分位数:${q1}<br />最小值:${low}`
            })
        ]
    }
    if(conf.type == 'candle') {
        return [
            `${conf.x.id}*start*end*high*low`, 
            (x, start, end, high, low) => ({ 
                name: x, 
                value:`<br/ >开盘价:${start}<br/ >收盘价:${end}<br />最高价:${high}<br />最低价:${low}`
            })
        ]
    }
    if(conf.type == 'pie' || conf.type == 'pyramid') {
        let y_title = transformField('title', conf.y.id, fields)
        let y_suffix = transformField('suffix', conf.y.id, fields)
        if(_.findIndex(fields, {'id':'ratio'})>=0) {
            let multi = 100
            if(transformField('suffix', 'ratio', fields)=='%') {
                multi = 1
            }
            return [
                `${conf.x.id}*${conf.y.id}*ratio`, 
                (x, y, ratio) => ({ 
                    name: x, 
                    value:`<br/ >${y_title?y_title:'值'}:${format(y)}${ratio?`<br/ >占比:${ratio*multi}%`:''}`
                })
            ]
        }
        return [
            `${conf.x.id}*${conf.y.id}`, 
            (x, y) => ({ 
                name: x, 
                value:`<br/ >${y_title?y_title:'值'}:${format(y)}${y_suffix?y_suffix:''}`
            })
        ]
    }
    if(conf.type == 'heatmap') {
        let value_title = conf.series&&conf.series.title?conf.series.title:'值'
        return [
            `${conf.x.id}*${conf.y.id}*${conf.series.id}`, 
            (x, y, value) => ({ 
                name: `x:${x} y:${y}`, 
                value:`<br/>${value_title}:${format(value)}`
            })
        ]
    }
    if(conf.type == 'worldmap' || conf.type == 'chinamap') {
        return [
            'name*value', 
            (name, value) => ({ 
                name: name, 
                value:` ${format(value)}`
            })
        ]
    }
    if(conf.type == 'treemap') {
        return [
            'name*value', 
            (name, value) => ({ 
                name: name, 
                value:` ${format(value)}`
            })
        ]
    }
    if(conf.type == 'mixin') {
        return [[
            `series*x*y*suffix`, 
            (series, x, y, suffix) => ({ 
                name: series, 
                value: ` ${format(y)}${y!=null&&y!=undefined?suffix:''}`
            })
        ], [
            `series*x*r*suffix`, 
            (series, x, r, suffix) => ({ 
                name: series, 
                value: ` ${format(r)}${r!=null&&r!=undefined?suffix:''}`
            })
        ]]
    }
    if (conf.type === 'polygon') {
        return [
            `${conf.x.id}*${conf.y.id}*${conf.series.id}`,
            (x, y, value) => ({ 
                name: `${x}，${y}`, 
                value:`${value}`
            })
        ]
    }
    let y_suffix = conf.y.suffix?conf.y.suffix:transformField('suffix', conf.y.id, fields)
    // 堆叠图增加占比
    if(conf.type === 'bar' && conf.series && conf.series.type && conf.series.type === 'stack') {
        if(conf.y.id !== 'ratio') {
            return [`${conf.x.id}*${conf.y.id}*${conf.series.id}*ratio`, (x, y, series, ratio)=>({name:series, value:`${format(y)}${y_suffix&&y!=null&&y!=undefined?y_suffix:''}
                ${ratio?`<span style="margin-left: 8px;font-weight: bold;">${ratio}%</span>`:''}`})]
        } else {
            return [`${conf.x.id}*${conf.y.id}*${conf.series.id}*ratio`, (x, y, series, ratio)=>({name:series, value:`${format(y)}${y_suffix&&y!=null&&y!=undefined?y_suffix:''}`})]
        }
    }
    if(conf.fixed===true && conf.x && conf.x.id=='ds') {
        return [`${conf.x.id}*${conf.y.id}*dt*dt_weekday*mark*${conf.y.id}_updown`, (x,y,dt,dt_weekday,mark,updown)=>({name:`${dt}${dt_weekday?`(${i18n && i18n.locale === 'zh_CN' ? "周" : ""}${dt_weekday})`:''}${mark?mark:''}`, value:`${format(y)} ${y_suffix&&y!=null&&y!=undefined?y_suffix:''} 
            ${(updown || updown==0) && updown!=undefined && updown!=null?`<span style="display:inline-block; min-width:50px; margin-left: 4px;color:${updown>=0?'red':'green'}">${updown==='-'?'-':updown+'%'}</span>`:''}`})]
    }
    if(conf.series) {
        return [`${conf.x.id}*${conf.y.id}*${conf.series.id}*${conf.y.id}_updown`, (x,y,series,updown)=>({name:series, value:`${format(y)}${y_suffix&&y!=null&&y!=undefined?y_suffix:''}
            ${(updown || updown==0) &&  updown!=undefined && updown!=null?`<span style="margin-left: 4px;color:${updown>=0?'red':'green'}">${updown==='-'?'-':updown+'%'}</span>`:''}`})]
    }
    let y_title = conf.y.title?conf.y.title:transformField('title', conf.y.id, fields)
    return [`${conf.x.id}*${conf.y.id}`, (x,y)=>({name:y_title, value:`${format(y)}${y_suffix?y_suffix:''}`})]
}

export const initFilter = (conf, fields, filter)=>{
    if(conf.type == 'mixin') {
        // 解析y
        if(conf.y) {
            if(filter) {
                return [{dataKey:'series', callback:(d) => {return filter.indexOf(d)>=0}}]
            }
            filter = []
            conf.y.forEach((y)=>{
                if(y.visible == false) {
                    let series = y.title?y.title:transformField('title', y.id, fields)
                    filter.push(series)
                }
            })
            if(filter.length >= 0) {
                return [{dataKey:'series', callback:(d) => {return filter.indexOf(d)<0}}]
            }
        }
    }
    else if(conf.series) {
        if(filter) {
            return [{dataKey:conf.series.id, callback:(d)=>{return filter.indexOf(d)>=0}}]
        }
        if( conf.series.filter) {
            // 如果类型是日期，支持加减操作
            let filters = []
            if(conf.series.id === 'dt' || conf.series.id === 'ds') {
                conf.series.filter.forEach(f=>{
                    filters.push(typeof f === 'number'?moment().add(f, 'day').format('YYYY-MM-DD'):f)
                })
            }
            else {
                filters = [...conf.series.filter]
            }
            return [{dataKey:conf.series.id, callback:(d)=>{return filters.indexOf(d)>=0 || conf.series.filter.indexOf(d)>=0}}]
        }
    }
    return []
}

// ------------------------------- 初始化数值格式 ------------------------------------
export const initLabel = (conf, fields)=>{
    let config = undefined
    if(conf.type=='pyramid') {
        config = {
            offset: 35,
            labelLine: {
                lineWidth: 1,
                stroke: 'rgba(0, 0, 0, 0.15)',
            }
        }
    }
    if(conf.other && conf.other.labelStyle) {
        config = conf.other.labelStyle
    }
    if(conf.type == 'pie' || conf.type == 'pyramid') {
        if(!config) {
            config = {}
        }
        if(_.findIndex(fields, {'id':'ratio'})>=0) {
            let multi = 100
            if(transformField('suffix', 'ratio', fields)=='%') {
                multi = 1
            }
            config.formatter = (val, item) => {return val?`${item.point[conf.x.id]}: ${val?(isNaN(val)?val:`${val*multi}%`):'0%'}`:null;}
            return ['ratio', config]
        }
        config.formatter = (val, item) => {return val?`${item.point[conf.x.id]}:${val}`:null;}
        return [conf.y.id, config]
    }
    if(conf.y && conf.type!='mixin') {
        if(config) {
            return [conf.y.id, config]
        }
        const _suffix = conf.y.suffix ? conf.y.suffix : transformField('suffix', conf.y.id, fields)
        if(conf.other && conf.other.labelSeries) {
            return [conf.y.id, {
                formatter: (val, item)=> {
                    if(item && item.point && item.point.series && conf.other.labelSeries.indexOf(item.point.series) >=0 ) {
                        return val?`${format(val)}${_suffix?_suffix:''}`:''
                    }
                }
            }]
        }
        else {
            return [conf.y.id, (val, item)=> {return val?`${format(val)}${_suffix?_suffix:''}`:''}]
        }
    }
    else if(conf.type === 'mixin') {
        return [['y', (val, item)=> {return val?format(val):''}], ['r', (val, item)=> {return val?format(val):''}]]
    }
    return config?config:{}
}

// ------------------------------- 初始化颜色 ------------------------------------
export const initColor = (y, colors)=>{
    let left_num = y.length - _.filter(y, {pos:'r'}).length
    let y_color=COLOR_PLATE_8, r_color=COLOR_PLATE_8
    // 有配色的情况
    if(colors) {
        if(y.length > colors.length) { 
            y_color = colors
            r_color = _.reverse(colors)
        }
        else {
            y_color = colors.slice(0, left_num)
            r_color = colors.slice(left_num)
        }
        return [y_color, r_color]
    }
    if(y.length<=8) {
        y_color = COLOR_PLATE_8.slice(0, left_num)
        r_color = COLOR_PLATE_8.slice(left_num)
    }
    else if(y.length<=16) {
        y_color = COLOR_PLATE_16.slice(0, left_num)
        r_color = COLOR_PLATE_16.slice(left_num)
    } 
    else if(y.length<=24) {
        y_color = COLOR_PLATE_24.slice(0, left_num)
        r_color = COLOR_PLATE_24.slice(left_num)
    } else {
        y_color = COLOR_PLATE_24
        r_color = _.reverse(COLOR_PLATE_24)
    }
    return [y_color, r_color]
}

export const initUdColor = (conf, udatas) => {
    let colors = initColor(conf.y, conf.color)
    if(conf.yaxis.left) {
        conf.yaxis.left.color = colors[0]
    }
    if(conf.yaxis.right) {
        conf.yaxis.right.color = colors[1]
    }
    let datas = _.cloneDeep(udatas)
    datas = _.filter(datas, (d)=>d.exclude_for_chart!=true)
    let lcolors = []
    let rcolors = []
    if(conf.yaxis.left && conf.yaxis.left.series_type === 'updown') {
        conf.y.forEach((lr) => {
            if(lr['pos'] == 'l') {
                if(lr['id'] && _.has(datas[0], [lr['id']]) && datas[0][lr['id']] >= 0) {
                    conf.yaxis.left.color.forEach((c) => {
                        lcolors.push(c)
                        lcolors.push('#f00')
                    })
                }
                if(lr['id'] && _.has(datas[0], [lr['id']]) && datas[0][lr['id']] < 0) {
                    conf.yaxis.left.color.forEach((c) => {
                        lcolors.push('#f00')
                        lcolors.push(c)
                    })
                }
            }
        })
        conf.yaxis.left.color = lcolors
    }
    if(conf.yaxis.right.series_type === 'updown') {
        conf.y.forEach((lr) => {
            if(lr['pos'] == 'r') {
                if(lr['id'] && _.has(datas[0], [lr['id']]) && datas[0][lr['id']] >= 0) {
                    conf.yaxis.left.color.forEach((c) => {
                        rcolors.push(c)
                        rcolors.push('#f00')
                    })
                }
                if(lr['id'] && _.has(datas[0], [lr['id']]) && datas[0][lr['id']] < 0) {
                    conf.yaxis.left.color.forEach((c) => {
                        rcolors.push('#f00')
                        rcolors.push(c)
                    })
                }
            }
        })
        conf.yaxis.right.color = rcolors
    }
}

const DEFAULT_COLOR = '#1890FF';
const COLOR_PLATE_8 = [
  '#1890FF',
  '#FFAE28',
  '#2FC25B',
  '#223273',
  '#8543E0',
  '#13C2C2',
  '#3436C7',
  '#F04864'
];
const COLOR_PLATE_16 = [
  '#1890FF',
  '#FFAE28',
  '#41D9C7',
  '#2FC25B',
  '#E6965C',
  '#223273',
  '#7564CC',
  '#8543E0',
  '#5C8EE6',
  '#13C2C2',
  '#5CA3E6',
  '#3436C7',
  '#B381E6',
  '#F04864',
  '#D598D9'
];
const COLOR_PLATE_24 = [ 
  '#1890FF',
  '#FFAE28',
  '#66B5FF',
  '#41D9C7',
  '#2FC25B',
  '#6EDB8F',
  '#9AE65C',
  '#E6965C',
  '#57AD71',
  '#223273',
  '#738AE6',
  '#7564CC',
  '#8543E0',
  '#A877ED',
  '#5C8EE6',
  '#13C2C2',
  '#70E0E0',
  '#5CA3E6',
  '#3436C7',
  '#8082FF',
  '#DD81E6',
  '#F04864',
  '#FA7D92',
  '#D598D9' ];
const COLOR_PIE = [
  '#1890FF',
  '#FFAE28',
  '#13C2C2',
  '#2FC25B',
  '#F04864',
  '#8543E0',
  '#3436C7',
  '#223273' ];
const COLOR_PIE_16 = [
  '#1890FF',
  '#FFAE28',
  '#73C9E6',
  '#13C2C2',
  '#6CD9B3',
  '#2FC25B',
  '#9DD96C',
  '#E6965C',
  '#F04864',
  '#D66BCA',
  '#8543E0',
  '#8E77ED',
  '#3436C7',
  '#737EE6',
  '#223273',
  '#7EA2E6'
];

export const DefaultTheme = {
    defaultColor: DEFAULT_COLOR, // 默认主题色
    colors: COLOR_PLATE_8,
    colors_16: COLOR_PLATE_16,
    colors_24: COLOR_PLATE_24,
    colors_pie: COLOR_PIE,
    colors_pie_16: COLOR_PIE_16,
}
